import { render, staticRenderFns } from "./DashboardBlocks.vue?vue&type=template&id=4b529010"
import script from "./DashboardBlocks.vue?vue&type=script&lang=js"
export * from "./DashboardBlocks.vue?vue&type=script&lang=js"
import style0 from "./DashboardBlocks.vue?vue&type=style&index=0&id=4b529010&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports